/**
 * Run an async operation on each item in parallel using `Promise.allSettled`,
 * then throw a summary error if any operations failed.
 *
 * Keeps selection intact on failure so the user can retry.
 */
export async function settleAll<T>(
  items: T[],
  fn: (item: T) => Promise<unknown>,
): Promise<void> {
  const results = await Promise.allSettled(items.map(fn));
  const failed = results.filter((r) => r.status === "rejected").length;
  if (failed) {
    throw new Error(`${failed} of ${results.length} failed`);
  }
}
